var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.774,
    height: 32,
    viewBox: "0 0 87.774 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#356ab2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#307ba9",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#24a893",
    stopOpacity: 0.961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20b78b",
    stopOpacity: 0.949
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2",
    transform: "translate(-15.999 -0.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(15.999 0.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M96.2,11.917v-.884h3.027v5.389c-.307.062-.854.146-1.632.248a15.476,15.476,0,0,1-1.942.153,3.692,3.692,0,0,1-3.333-1.413,7.873,7.873,0,0,1-.931-4.279,13.3,13.3,0,0,1,.193-2.439A5.265,5.265,0,0,1,92.253,6.9,3.593,3.593,0,0,1,95.627,5.36a16.1,16.1,0,0,1,3.063.3l.526.113-.047.851a19.642,19.642,0,0,0-3.461-.365,2.78,2.78,0,0,0-2.621,1.161,7.621,7.621,0,0,0-.672,3.691,7.421,7.421,0,0,0,.683,3.673,2.8,2.8,0,0,0,2.6,1.139,14.7,14.7,0,0,0,2.556-.256V11.917Z",
    transform: "translate(-58.022 -3.403)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M119.14,22.1V14.066h.946V15.22a8.828,8.828,0,0,1,1.46-.8,6.984,6.984,0,0,1,1.559-.5v.964a8.686,8.686,0,0,0-1.46.442,11.408,11.408,0,0,0-1.168.518l-.42.241V22.1Z",
    transform: "translate(-75.643 -8.838)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M132.54,18.075a5.216,5.216,0,0,1,.759-3.209,4.041,4.041,0,0,1,5.2,0,5.193,5.193,0,0,1,.763,3.209,5.64,5.64,0,0,1-.7,3.22,4.147,4.147,0,0,1-5.316,0A5.59,5.59,0,0,1,132.54,18.075Zm.993-.026a5.5,5.5,0,0,0,.442,2.629q.442.73,1.924.73c.986,0,1.632-.245,1.931-.73a5.41,5.41,0,0,0,.449-2.621,4.688,4.688,0,0,0-.5-2.581,2.865,2.865,0,0,0-3.738-.007A4.622,4.622,0,0,0,133.533,18.049Z",
    transform: "translate(-84.151 -8.838)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M154.45,14.341h.978l1.778,7.17h.223l2.085-7.021h1.011l2.07,7.021h.241L164.6,14.33h.975l-2,8.032h-1.668l-1.891-6.6-1.909,6.6h-1.65Z",
    transform: "translate(-98.062 -9.098)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M189.67,6.781V5.58h.946v1.2Zm0,10.022V8.771h.946V16.8Z",
    transform: "translate(-120.424 -3.543)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M199.789,22.1h-.949V14.072h.949v.613a5.327,5.327,0,0,1,2.61-.756,2.357,2.357,0,0,1,2.143.851,6.265,6.265,0,0,1,.537,3.111V22.1h-.964V17.935a5.647,5.647,0,0,0-.365-2.494,1.565,1.565,0,0,0-1.508-.65,4.451,4.451,0,0,0-1.179.172,4.746,4.746,0,0,0-.953.343l-.336.161Z",
    transform: "translate(-126.246 -8.844)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M228.078,23.281a2.237,2.237,0,0,1-.873,1.975,4.791,4.791,0,0,1-2.716.61,4.512,4.512,0,0,1-2.556-.529,2.279,2.279,0,0,1-.708-1.942,1.847,1.847,0,0,1,.288-1.1,4.553,4.553,0,0,1,1.011-.938,1.219,1.219,0,0,1-.4-1.1,2.938,2.938,0,0,1,.387-1.008l.128-.241a2.329,2.329,0,0,1-1.314-2.421q0-2.727,2.9-2.727a5.882,5.882,0,0,1,1.442.161l.241.047,2.322-.047v.851l-1.6-.033a2.577,2.577,0,0,1,.577,1.9,2.331,2.331,0,0,1-.73,1.92,3.624,3.624,0,0,1-2.3.6,4.911,4.911,0,0,1-.818-.062,3.882,3.882,0,0,0-.318.993c0,.365.1.57.31.65a8.1,8.1,0,0,0,1.869.128,3.9,3.9,0,0,1,2.191.464A2.183,2.183,0,0,1,228.078,23.281Zm-5.882.051a1.568,1.568,0,0,0,.482,1.329,3.379,3.379,0,0,0,1.858.365,3.734,3.734,0,0,0,1.971-.391,1.46,1.46,0,0,0,.6-1.314c0-.617-.146-1.015-.434-1.2a3.457,3.457,0,0,0-1.65-.27l-1.825-.066a3.165,3.165,0,0,0-.8.73,1.434,1.434,0,0,0-.186.814Zm.113-6.725a1.948,1.948,0,0,0,.449,1.46,2.168,2.168,0,0,0,1.511.427,2.192,2.192,0,0,0,1.515-.42,1.946,1.946,0,0,0,.449-1.46,2.026,2.026,0,0,0-.449-1.486,2.147,2.147,0,0,0-1.515-.431,2.1,2.1,0,0,0-1.511.442,2.011,2.011,0,0,0-.438,1.468Z",
    transform: "translate(-140.457 -8.805)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M96.253,55.7H94.008v3.414H92.23V48.13h4.016q3.735,0,3.735,3.687a4.061,4.061,0,0,1-.938,2.888A3.643,3.643,0,0,1,96.253,55.7Zm-2.245-1.541h2.227c1.285,0,1.924-.778,1.924-2.34a2.391,2.391,0,0,0-.464-1.636,1.887,1.887,0,0,0-1.46-.511H94.008Z",
    transform: "translate(-58.558 -30.558)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M122.65,62.514l.449-.047.033,1.3a16.72,16.72,0,0,1-3.238.365,3.075,3.075,0,0,1-2.556-.978,5.053,5.053,0,0,1-.778-3.129q0-4.261,3.479-4.264,3.366,0,3.366,3.673l-.11,1.249H118.32a2.19,2.19,0,0,0,.434,1.46,2.044,2.044,0,0,0,1.555.464C121.069,62.605,121.832,62.58,122.65,62.514Zm-.964-3.173a2.825,2.825,0,0,0-.365-1.661,1.541,1.541,0,0,0-1.274-.471,1.6,1.6,0,0,0-1.307.5,2.658,2.658,0,0,0-.424,1.636Z",
    transform: "translate(-74.005 -35.403)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M139.685,56.814a3.3,3.3,0,0,1,2.749-1.044,3.355,3.355,0,0,1,2.749,1.044,4.894,4.894,0,0,1,.825,3.125,5.183,5.183,0,0,1-.8,3.143,3.262,3.262,0,0,1-2.775,1.059,3.3,3.3,0,0,1-2.771-1.059,5.145,5.145,0,0,1-.8-3.143A4.96,4.96,0,0,1,139.685,56.814Zm1.307,5.21a1.536,1.536,0,0,0,1.46.643,1.5,1.5,0,0,0,1.442-.643,4.458,4.458,0,0,0,.365-2.1,4.021,4.021,0,0,0-.391-2.07,1.955,1.955,0,0,0-2.837,0,4.035,4.035,0,0,0-.394,2.07A4.45,4.45,0,0,0,140.992,62.024Z",
    transform: "translate(-88.164 -35.409)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M163.19,67.409V55.949h1.73v.5a4.016,4.016,0,0,1,2.066-.675,2.746,2.746,0,0,1,2.326.971,5.43,5.43,0,0,1,.73,3.253,4.816,4.816,0,0,1-.84,3.216,3.546,3.546,0,0,1-2.749.931A9.564,9.564,0,0,1,164.928,64v3.414Zm3.494-10.095a3.7,3.7,0,0,0-1.508.336l-.241.113v4.746a7.335,7.335,0,0,0,1.413.128,1.681,1.681,0,0,0,1.508-.624,4,4,0,0,0,.416-2.132Q168.272,57.314,166.684,57.314Z",
    transform: "translate(-103.611 -35.409)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M187,58.471V47.12h1.749V58.471Z",
    transform: "translate(-118.728 -29.917)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M202.92,62.514l.449-.047.033,1.3a16.721,16.721,0,0,1-3.238.365,3.075,3.075,0,0,1-2.556-.978,5.053,5.053,0,0,1-.778-3.129q0-4.261,3.479-4.264,3.366,0,3.366,3.673l-.11,1.249H198.59a2.191,2.191,0,0,0,.434,1.46,2.044,2.044,0,0,0,1.555.464C201.339,62.605,202.116,62.58,202.92,62.514Zm-.96-3.173a2.853,2.853,0,0,0-.365-1.661,1.541,1.541,0,0,0-1.274-.471,1.6,1.6,0,0,0-1.307.5,2.658,2.658,0,0,0-.423,1.636Z",
    transform: "translate(-124.97 -35.403)",
    fill: "#302e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M19.392,28.648a1.774,1.774,0,0,1-.73.884,1.647,1.647,0,0,1-1.055.237A1.672,1.672,0,0,1,16.1,28.648L10.667,15.041l.862.128L6.607,28.648a1.61,1.61,0,0,1-1.5,1.121,1.742,1.742,0,0,1-1.1-.237,1.88,1.88,0,0,1-.73-.884L.127,20.014A2,2,0,0,1,0,19.324a1.778,1.778,0,0,1,.475-1.252,1.668,1.668,0,0,1,1.3-.518,1.825,1.825,0,0,1,.949.256,1.42,1.42,0,0,1,.606.865L5.57,25.15l-.909-.044L9.674,12.146a1.661,1.661,0,0,1,1.639-1.1,1.559,1.559,0,0,1,.971.281,1.61,1.61,0,0,1,.54.8L18.1,25.092l-1.1.084L25.478,1.124A1.539,1.539,0,0,1,27.121,0a1.654,1.654,0,0,1,1.187.475,1.526,1.526,0,0,1,.533,1.3,1.245,1.245,0,0,1-.066.365M13.715,6.487A2.348,2.348,0,1,1,11.368,4.14a2.348,2.348,0,0,1,2.348,2.348Z",
    transform: "translate(0.001 0.001)",
    fill: "url(#linear-gradient)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.07da149c5326de952bceb73d98a82ee6.svg";
export { ForwardRef as ReactComponent };